export default "__VITE_ASSET__D9dmrteE__"